import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CorporateTrackingStatusComponent } from './corporate-tracking-status.component';
import { PaymentStatusBadgePipeModule } from '@pipes/payment-status-badge/payment-status-badge.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [CorporateTrackingStatusComponent],
  imports: [CommonModule, TranslateModule, PaymentStatusBadgePipeModule],
  exports: [CorporateTrackingStatusComponent],
})
export class CorporateTrackingStatusModule {}
